<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
	<ms-page-title />

	<!-- Page Header -->
	<div class="page-title-wrapper">
		<div class="d-flex justify-content-between flex-row flex-wrap gap-3 align-items-start">
			<div>
				<!-- Search Input Group -->
				<div class="input-group position-relative">
					<input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
						placeholder="Search Chart of Accounts" aria-label="Search Chart of Accounts"
						[(ngModel)]="searchTermInput"
						(keyup.enter)="applySearch()" aria-describedby="search-description">

					@if (searchTermInput) {
						<button class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
							type="button" (click)="clearSearch()" aria-label="Clear search">
							<fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
						</button>
					}

					<div class="input-group-append">
						<button class="btn btn-primary rounded-0 rounded-end" type="button" (click)="applySearch()">
							Search
						</button>
					</div>
				</div>
				<!-- Search Input Group -->
				<div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
					Search by account number, name, or description
				</div>
			</div>

			<div class="d-flex gap-3">
				<select class="form-select form-control-solid" aria-label="Filter by status"
					[(ngModel)]="statusFilter">
					<option value="active">Active</option>
					<option value="retired">Retired</option>
					<option value="all">All</option>
				</select>

				<ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy"
					(selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>

				<button type="button" class="btn btn-ms-secondary" (click)="openActivityLog()">
					<fa-duotone-icon icon="clock-rotate-left" secondaryOpacity="0.9" class="d-none d-sm-inline me-2" />
					Activity Log
				</button>
			</div>
		</div>
	</div>

	@for (category of categories; track category) {
		<ms-chart-of-account-category-section [category]="category" [organizationId]="organizationId()"
			[searchTerm]="appliedSearchTerm" [isActive]="isActiveFilterValue" [sortOption]="orderBy" />
	}
</div>

<!-- Chart of accounts audit logs are organization-scoped, not per-account — one shared activity feed
     for the whole org rather than a per-row history action. -->
<div class="modal fade" id="coaActivityLogModal" msEscClose (escPressed)="closeActivityLog()"
	data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
		<div class="modal-content">
			<div class="modal-header border-0 p-4">
				<h5 class="modal-title">Chart of Accounts Activity</h5>
			</div>
			<div class="modal-body">
				@if (isActivityLogOpen() && organizationId()) {
					<ms-audit-logs [entityId]="organizationId()" [entityType]="AuditEntityType.ChartOfAccount" />
				}
			</div>
			<div class="modal-footer border-0 d-flex justify-content-center pb-4">
				<button type="button" class="btn btn-ms-secondary" (click)="closeActivityLog()">Close</button>
			</div>
		</div>
	</div>
</div>
